import React, { Component } from "react";
import clsx from "clsx";

import ToolsCheckbox from "./ToolsCheckbox";

class ToolsAcknowledgeNotice extends Component {
	render() {
		const { message, checked, onChange, label = "I've read this and want to go ahead anyway", className, dataTest } = this.props;
		return (
			<div className={clsx("tk-notice", "tk-notice--warning", className)} data-test={dataTest}>
				<p className="tk-notice__detail">{message}</p>
				{onChange && (
					<div className="tk-acknowledge__choice">
						<ToolsCheckbox checked={checked} onChange={onChange} label={label} size="form" />
					</div>
				)}
			</div>
		);
	}
}

export default ToolsAcknowledgeNotice;
